"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ParagraphElement_1 = require("./ParagraphElement");
const HeadingElement_1 = require("./HeadingElement");
const BlockquoteElement_1 = require("./BlockquoteElement");
const CalloutElement_1 = require("../../block/callout/CalloutElement");
const CodeBlock_1 = require("./code-block/CodeBlock");
const PreformattedElement_1 = require("./PreformattedElement");
const EmbedElement_1 = require("./EmbedElement");
const HrElement_1 = require("./hr/HrElement");
const ListElement_1 = require("./ListElement");
const TwoColumnsElement_1 = require("./TwoColumnsElement");
const FileElement_1 = require("./file/FileElement");
const TocElement_1 = require("./toc/TocElement");
const MathElement_1 = require("./math/MathElement");
const MathInlineElement_1 = require("./math/MathInlineElement");
const BlockElement = (props) => {
    switch (props.element.type) {
        case 'columns':
            return React.createElement(TwoColumnsElement_1.TwoColumnsElement, { ...props });
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
        case 'title':
        case 'subtitle':
            return React.createElement(HeadingElement_1.HeadingElement, { ...props });
        case 'blockquote':
            return React.createElement(BlockquoteElement_1.BlockquoteElement, { ...props });
        case 'callout':
            return React.createElement(CalloutElement_1.CalloutElement, { ...props });
        case 'code-block':
            return React.createElement(CodeBlock_1.CodeBlock, { ...props });
        case 'pre':
            return React.createElement(PreformattedElement_1.PreformattedElement, { ...props });
        case 'embed':
            return React.createElement(EmbedElement_1.EmbedElement, { ...props });
        case 'hr':
            return React.createElement(HrElement_1.HrElement, { ...props });
        case 'file':
            return React.createElement(FileElement_1.FileElement, { ...props });
        case 'toc':
            return React.createElement(TocElement_1.TocElement, { ...props });
        case 'math':
            return React.createElement(MathElement_1.MathElement, { ...props });
        case 'math-inline':
            return React.createElement(MathInlineElement_1.MathInlineElement, { ...props });
        case 'ul':
        case 'ol':
        case 'checklist':
        case 'stepper':
            return React.createElement(ListElement_1.ListContainerElement, { ...props });
        case 'li':
            return React.createElement(ListElement_1.ListItemElement, { ...props });
        default:
            return React.createElement(ParagraphElement_1.ParagraphElement, { ...props });
    }
};
exports.BlockElement = BlockElement;
